<template>
	<v-simple-table>
		<template v-slot:default>
		<thead>
			<tr>
				<th class="text-left">
					Place
				</th>
				<th class="text-left">
				</th>
				<th class="text-left">
					Artist Name
				</th>
				<th class="text-left">
					Genres
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="(item, index) in items"
				:key="index"
			>
			<td><b>{{ index + 1 }}</b></td>
			<td><v-img :src="item.images[0].url" width="128" height="128"/></td>
			<td><a :href="item.uri">{{ item.name }}</a></td>
			<td><span v-for="(genres, i) in item.genres" :key="i">
				{{ capitalizeFirstLetters(genres) }}<span v-if="i !== item.genres.length - 1">, </span>
			</span></td>
			</tr>
		</tbody>
		</template>
	</v-simple-table>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			required: true
		}
	},
	methods: {
		capitalizeFirstLetters(string) {
			const words = string.split(' ');
			words.forEach((word, i) => words[i] = word.charAt(0).toUpperCase() + word.slice(1));

			return words.join(' ');
		}
	}
}
</script>